import { render, staticRenderFns } from "./alibabaProductItem.vue?vue&type=template&id=26b915c8&scoped=true&"
import script from "./alibabaProductItem.vue?vue&type=script&lang=js&"
export * from "./alibabaProductItem.vue?vue&type=script&lang=js&"
import style0 from "./alibabaProductItem.vue?vue&type=style&index=0&id=26b915c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26b915c8",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/views/alibaba/product/components/alibabaProductItem.vue
// module id = null
// module chunks = 